import App from './App'
import Vue from 'vue'

import router from './router'
import Vuex from 'vuex';
import store from './store/modules/index.js'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import BootstrapVue from 'bootstrap-vue'
import VueExpandableImage from 'vue-expandable-image'
import axios from"axios"
import VueApexCharts from 'vue-apexcharts'

import 'v-slim-dialog/dist/v-slim-dialog.css'
import SlimDialog from 'v-slim-dialog'

import 'vuetify/dist/vuetify.min.css'
import 'font-awesome/css/font-awesome.css'

import 'material-design-icons-iconfont/dist/material-design-icons.css'

import "./styles/global.css"

import timeSerfice from './services/TimeService.js'

import Mgr from './services/SecureService';
let mgr = new Mgr();

import Toolbar from './components/Toolbar.vue';
import Navigation from './components/Navigation.vue';
import Footer from './components/Footer.vue';
import vuetify from './plugins/vuetify';

import './assets/scrollbar.css'


Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

Vue.component('toolbar', Toolbar);
Vue.component('navigation', Navigation);
Vue.component('page-footer', Footer);

Vue.prototype.$http = axios;

Vue.use(SlimDialog);
Vue.use(Vuex);
Vue.use(timeSerfice);
Vue.use(mgr);
Vue.use(BootstrapVue);
Vue.use(VueExpandableImage);

Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    if (requiresAuth) {
        mgr.getUser().then(
            user => {
                if(user){
                    /*var intersection= to.meta.accessRole.filter(function(value){
                        return user.profile.role==value||user.profile.role.indexOf(value)!=-1;
                    });
                    if(intersection.length>0){*/
                        store.commit("userData/setSignedIn", true)
                        next();
                    /*}
                    else {
                        store.commit("userData/setSignedIn", false)
                        next('/Error/403');
                    }*/
                }else {
                    store.commit("userData/setSignedIn", false)
                    next('/Error/403');
                }
            },
            err => {
                console.log(err);
            }
        );
    } else {

        next();
    }
});

new Vue({
    store,
    router,
    components: { App },

    data: {
        connection: null,
        themeColor: '#FAFAFA',
        docsUrl: process.env.VUE_APP_DOCS,
        baseUrl: process.env.VUE_APP_LINK,
        identityURL:process.env.VUE_APP_IDENTITY

    },
    vuetify,
    render: h => h(App)
}).$mount('#app')
